import React from "react"
import loader from "assets/images/loader.svg"

const CircularProgress = ({fullScreen = false, className = ''}) =>
  <div className={`loader ${className}`} style={{height: fullScreen ? '100vh' : 'auto'}}>
  <img src={loader} alt="loader"/>
</div>;
export default CircularProgress;
